import DebouncedInput from "@/components/DebouncedInput";
import SelectFilter from "@/components/SelectFilter";
import { Box, HStack } from "@chakra-ui/react";
import { User } from "lucide-react";
import { Dispatch, SetStateAction, useCallback } from "react";
import { FiltersType } from "../types/filters.type";

type Props = {
  queryFilters: FiltersType;
  setQueryFilters: Dispatch<SetStateAction<FiltersType>>;
};

const Filters = ({ queryFilters, setQueryFilters }: Props): JSX.Element => {
  const handleSearchById = useCallback(
    (value: string) =>
      setQueryFilters((prev) => ({ ...prev, clientId: value })),
    [setQueryFilters]
  );

  const handleSearchByWhatsapp = (option: string | undefined) => {
    setQueryFilters((prev) => ({ ...prev, whatsAppFilter: option }));
  };

  return (
    <Box display={"flex"} gap={"1rem"}>
      <HStack flexGrow={1} position="relative">
        <Box position="absolute" right={3} zIndex={1}>
          <User size={18} color="#9F9DB0" />
        </Box>
        <DebouncedInput
          size="sm"
          placeholder="Cédula"
          _placeholder={{ color: "#5D5C60" }}
          value={queryFilters.clientId}
          onDebouncedChange={handleSearchById}
        />
      </HStack>
      <SelectFilter
        options={["Habilitado", "Deshabilitado"]}
        selectedOption={queryFilters.whatsAppFilter}
        onSelect={handleSearchByWhatsapp}
        placeholder="WhatsApp"
        width="50%"
      />
    </Box>
  );
};

export default Filters;
